/* Tathagat Media Work index.
   Progressive enhancement: the page is fully readable without this file. It adds scroll reveal, light parallax
   (via the --wi-p custom property) and a touch press state. Transforms and opacity only, so nothing shifts layout. */
(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-wi]');
  if (!roots.length) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  Array.prototype.forEach.call(roots, init);

  function init(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-wi-reveal]'));
    var projects = Array.prototype.slice.call(root.querySelectorAll('[data-wi-project]'));

    bindPress(projects);

    if (reduceMotion.matches || !('IntersectionObserver' in window)) return;

    root.classList.add('wi-js');
    revealOnScroll(items);
    parallax(projects);
  }

  function revealOnScroll(items) {
    var pending = items.slice();
    var ticking = false;

    function show(el) {
      el.classList.add('is-in');
      io.unobserve(el);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // Items already scrolled past (anchor jump, reload mid-page) must not stay hidden.
        if (entry.isIntersecting || entry.boundingClientRect.top < 0) show(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    items.forEach(function (el) { io.observe(el); });

    // The observer can miss items on fast scrolls or throttled frames, so sweep on scroll as a safety net.
    function sweep() {
      ticking = false;
      var limit = window.innerHeight * 0.94;
      pending = pending.filter(function (el) {
        if (el.classList.contains('is-in')) return false;
        if (el.getBoundingClientRect().top < limit) { show(el); return false; }
        return true;
      });
      if (!pending.length) window.removeEventListener('scroll', schedule);
    }

    function schedule() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(sweep);
    }

    window.addEventListener('scroll', schedule, { passive: true });
  }

  function parallax(projects) {
    var visible = new Set();
    var ticking = false;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) visible.add(entry.target); else visible.delete(entry.target);
      });
      schedule();
    }, { rootMargin: '20% 0px' });
    projects.forEach(function (el) { io.observe(el); });

    function update() {
      ticking = false;
      if (reduceMotion.matches) {
        visible.forEach(function (el) { el.style.removeProperty('--wi-p'); });
        return;
      }
      var vh = window.innerHeight;
      visible.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var p = ((r.top + r.height / 2) - vh / 2) / (vh / 2 + r.height / 2);
        el.style.setProperty('--wi-p', Math.max(-1, Math.min(1, p)).toFixed(3));
      });
    }

    function schedule() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    schedule();
  }

  // Touch has no hover, so a press gives the same kind of feedback. It never blocks the link underneath.
  function bindPress(projects) {
    projects.forEach(function (project) {
      var stage = project.querySelector('[data-wi-stage]');
      if (!stage) return;
      function release() { project.classList.remove('is-pressed'); }
      stage.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse') project.classList.add('is-pressed');
      });
      stage.addEventListener('pointerup', release);
      stage.addEventListener('pointercancel', release);
      stage.addEventListener('pointerleave', release);
    });
  }
})();
